/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MaterialDTO } from './MaterialDTO';
import {
    MaterialDTOFromJSON,
    MaterialDTOFromJSONTyped,
    MaterialDTOToJSON,
} from './MaterialDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface MaterialPageDTO
 */
export interface MaterialPageDTO {
    /**
     * 
     * @type {Array<MaterialDTO>}
     * @memberof MaterialPageDTO
     */
    content?: Array<MaterialDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof MaterialPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaterialPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MaterialPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof MaterialPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof MaterialPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof MaterialPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof MaterialPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof MaterialPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof MaterialPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the MaterialPageDTO interface.
 */
export function instanceOfMaterialPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MaterialPageDTOFromJSON(json: any): MaterialPageDTO {
    return MaterialPageDTOFromJSONTyped(json, false);
}

export function MaterialPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(MaterialDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function MaterialPageDTOToJSON(value?: MaterialPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(MaterialDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

